/**
 * Relative timestamps for the demo data.
 *
 * The prototype showed things like "hace 2 horas". Anchoring the fixtures to
 * the current clock keeps those labels correct whenever the app is opened.
 */
const HOUR = 60 * 60 * 1000;
const DAY = 24 * HOUR;

export const hoursAgo = (hours: number): string =>
  new Date(Date.now() - hours * HOUR).toISOString();
export const daysAgo = (days: number): string => new Date(Date.now() - days * DAY).toISOString();
export const daysAhead = (days: number): string => new Date(Date.now() + days * DAY).toISOString();

/** Calendar date `days` from today, as YYYY-MM-DD. */
export const dateIn = (days: number): string =>
  new Date(Date.now() + days * DAY).toISOString().slice(0, 10);
